window.$ = window.jQuery = require('jquery');

require('./common/recaptchav3');
require('./common/currentLocale');
require('./common/validator');